export default __webpack_public_path__ + "static/media/ilustracao-mulher-com-livro-desktop.5076e826.svg";